// Small helpers so components read clearly:
//
//   const canSeeCost = usePermission('products.view_cost');
//
// As with the store, this only decides what to draw. The server decides what
// is actually allowed.

import { useAuthStore } from '../stores/authStore';

export function usePermission(permission: string): boolean {
  return useAuthStore((state) => state.permissions.has(permission));
}

export function useAnyPermission(permissions: string[]): boolean {
  return useAuthStore((state) => permissions.some((permission) => state.permissions.has(permission)));
}

export function useCurrentUser() {
  return useAuthStore((state) => state.user);
}

export function useCurrentRole() {
  return useAuthStore((state) => state.role);
}
